import React from "react";
import Error500 from "../../Pages/Error/500/Error500";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: '', hasError: false };
    }

    promiseRejectionHandler = (event) => {
        this.setState({
            error: event.reason,
            hasError: true
        });
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { error: error, hasError: true };
    }

    componentDidMount() {
      window.addEventListener('unhandledrejection', this.promiseRejectionHandler)
    }

    componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
    }
 
    componentDidUpdate(prevProps, prevState, snapshot) {
      const childNow = React.Children.only(this.props.children);
      const childPrev = React.Children.only(prevProps.children);
  
      if (childNow !== childPrev) {
          this.setState({ error: "", hasError: false });
     }
    }

    resetErrorBoundary() {
        this.setState({ hasError: false });
    }
  
    componentDidCatch(error, info) {
      // Example "componentStack":
      //   in ComponentThatThrows (created by App)
      //   in ErrorBoundary (created by App)
      //   in div (created by App)
      //   in App
      this.setState({
        error: error,
        hasError: true
      })
      //logErrorToMyService(error, info.componentStack);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        
        return <Error500 error={this.state.error} reset={this.resetErrorBoundary} />
      }
  
      return this.props.children;
    }
  }